var render = function render(){var _vm=this,_c=_vm._self._c;return _c('curriculum-page',{attrs:{"resource-params":_vm.resourceParams}})
}
var staticRenderFns = []

export { render, staticRenderFns }